module.exports = __webpack_public_path__ + "f038d0151ea9491f85036b1ef6619d3a.png";